// extracted by mini-css-extract-plugin
export var card = "_lu-5";
export var cardSelected = "_lu-4";
export var image = "_lu-3";
export var modal = "_lu-0";
export var modalContent = "_lu-1";
export var table = "_lu-2";